import axios from "axios";
import { getToken } from "../hooks/actions/sessionActions";
import { trackApiError } from "../analytics/trackApiError";

const ApiMServer = axios.create({
  baseURL: process.env.REACT_APP_API_MOTOMCO,
});

ApiMServer.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

ApiMServer.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.response?.data?.error === "TokenExpiredError") {
      window.location.href = '/logout';
    } else {
      trackApiError(error);
    }
    return Promise.reject(error);
  }
);

export default ApiMServer;
